import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=1144293f&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=1144293f&prod&lang=css&"
import style1 from "./detail.vue?vue&type=style&index=1&id=1144293f&prod&scoped=true&lang=css&"
import style2 from "./detail.vue?vue&type=style&index=2&id=1144293f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1144293f",
  null
  
)

export default component.exports